/* Subscription recipient client data model (Recipient)
 *
 */

import Subscription from "./Subscription";

import makePropsEnumerable from "../utility/MakePropsEnumerable";

const mRecipientId = new WeakMap();
const mRecipientName = new WeakMap();
const mRecipientEmail = new WeakMap();
const mRecipientIsInternal = new WeakMap();
const mRecipientNotes = new WeakMap();
const mRecipientSubscriptions = new WeakMap();

class Recipient {
    constructor({
        id: recipientId,
        name: recipientName,
        email: recipientEmail,
        isInternal: recipientIsInternal,
        notes: recipientNotes,
        subs: recipientSubscriptions
    })
    {
        this.recipientId = recipientId;
        this.recipientName = recipientName;
        this.recipientEmail = recipientEmail;
        this.recipientIsInternal = recipientIsInternal;
        this.recipientNotes = recipientNotes;

        mRecipientSubscriptions.set(this, []);
        if ((recipientSubscriptions !== undefined) &&
            (recipientSubscriptions != null))
        {
            Array.prototype.push.apply(
                this.recipientSubscriptions,
                recipientSubscriptions
            );
        }
    }

    get recipientId() {
        return mRecipientId.get(this);
    }

    set recipientId(updatedVal) {
        if ((updatedVal != null) &&
            (Number.isFinite(updatedVal)))
        {
            mRecipientId.set(this, updatedVal);
        }
        else {
            throw new TypeError("Null or missing recipient id.");
        }
    }

    get recipientName() {
        return mRecipientName.get(this);
    }

    set recipientName(updatedVal) {
        if ((updatedVal != null) &&
            (typeof(updatedVal) === "string"))
        {
            mRecipientName.set(this, updatedVal);
        }
        else {
            throw new TypeError("Null or missing recipient name.");
        }
    }

    get recipientEmail() {
        return mRecipientEmail.get(this);
    }

    set recipientEmail(updatedVal) {
        if ((updatedVal != null) &&
            (typeof(updatedVal) === "string"))
        {
           mRecipientEmail.set(this, updatedVal);
        }
        else {
            throw new TypeError("Null or missing recipient email.");
        }
    }

    get recipientIsInternal() {
        return mRecipientIsInternal.get(this);
    }

    set recipientIsInternal(updatedVal) {
        mRecipientIsInternal.set(this, (updatedVal === true));
    }

    get recipientNotes() {
        return mRecipientNotes.get(this);
    }

    set recipientNotes(updatedVal) {
        mRecipientNotes.set(this, updatedVal);
    }

    get recipientSubscriptions() {
        return mRecipientSubscriptions.get(this);
    }

    toString() {
        return `${this.recipientName}/${this.recipientEmail}/${this.recipientId}`;
    }

    valueOf() {
        return this.recipientId;
    }

    toServerRecipient() {
        return {
            RecipientId: this.recipientId,
            RecipientName: this.recipientName,
            RecipientEmail: this.recipientEmail,
            RecipientIsInternal: this.recipientIsInternal,
            RecipientNotes: this.recipientNotes
        };
    }

    static CopyRecipient(otherRecipient) {
        if (otherRecipient != null) {
            return new Recipient({
                id: otherRecipient.recipientId,
                name: otherRecipient.recipientName,
                email: otherRecipient.recipientEmail,
                isInternal: otherRecipient.recipientIsInternal,
                notes: otherRecipient.recipientNotes,
                subs: otherRecipient.recipientSubscriptions
            });
        }
        else {
            return null;
        }
    }

    static CreateBlankRecipient() {
        return new Recipient({
            id: 0,
            name: "",
            email: "",
            isInternal: false,
            notes: null,
            subs: undefined
        });
    }

    static FromServerRecipient(serverRecipient) {

        if (serverRecipient == null) {
            return null;
        }

        let recipientSubscriptions = [];

        if ((serverRecipient["Subscriptions"] !== undefined) &&
            (serverRecipient["Subscriptions"] != null))
        {
            serverRecipient.Subscriptions.forEach(function(svrSubscription) {
                recipientSubscriptions.push(
                    Subscription.FromServerSubscription(svrSubscription)
                );
            });

        }

        return new Recipient({
            id: serverRecipient.RecipientId,
            name: serverRecipient.RecipientName,
            email: serverRecipient.RecipientEmail,
            isInternal: serverRecipient.RecipientIsInternal,
            notes: serverRecipient.RecipientNotes,
            subs: recipientSubscriptions
        });
    }

}

makePropsEnumerable(Recipient.prototype, [
    "recipientId",
    "recipientName",
    "recipientEmail",
    "recipientIsInternal",
    "recipientNotes",
    "recipientSubscriptions",
    "toServerRecipient"
]);

export default Recipient;


//////////////////
// WEBPACK FOOTER
// ./src/models/Recipient.js
// module id = WkRR
// module chunks = 1